export default __webpack_public_path__ + "static/media/Icecream & Berries - proportioned_170.780f66da.jpg";